import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
export const API = `${BACKEND_URL.replace(/\/$/, "")}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const activeTenantId = String(localStorage.getItem("voxyra-active-tenant-id") || "").trim();
  const requestUrl = String(config?.url || "").trim();
  const skipTenantScope =
    config?.skipTenantScope === true ||
    requestUrl === "/tenants" ||
    requestUrl.startsWith("/tenants?");
  if (activeTenantId && !skipTenantScope) {
    config.headers = config.headers || {};
    config.headers["x-active-tenant-id"] = activeTenantId;
  }
  return config;
});

export function fmtDate(iso) {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    return d.toLocaleString("pt-BR", { hour12: false });
  } catch (_) { return iso; }
}

export function fmtDuration(sec) {
  if (!sec && sec !== 0) return "-";
  const s = Math.max(0, sec | 0);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const r = s % 60;
  return `${h.toString().padStart(2, "0")}:${m.toString().padStart(2, "0")}:${r.toString().padStart(2, "0")}`;
}

export function apiErrToStr(detail) {
  if (detail == null) return "Erro desconhecido";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" | ");
  }
  if (typeof detail === "object" && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

const HANGUP_CAUSE_LABELS = {
  NORMAL_CLEARING: "Encerrada normalmente",
  NO_ANSWER: "Nao atendida",
  USER_BUSY: "Usuario ocupado",
  CALL_REJECTED: "Chamada rejeitada",
  ORIGINATOR_CANCEL: "Cancelada na origem",
  NORMAL_TEMPORARY_FAILURE: "Falha temporaria",
  NO_ROUTE_DESTINATION: "Sem rota para o destino",
  UNALLOCATED_NUMBER: "Numero inexistente",
  ALLOTTED_TIMEOUT: "Tempo esgotado",
  MANAGER_REQUEST: "Encerrada pelo operador",
  SERVICE_UNAVAILABLE: "Servico indisponivel",
  CONGESTION: "Congestionamento",
  REQUESTED_CHAN_UNAVAIL: "Canal indisponivel",
  NETWORK_OUT_OF_ORDER: "Falha de rede",
  RECOVERY_ON_TIMER_EXPIRE: "Tempo de sessao expirado",
  MANDATORY_IE_MISSING: "Informacao obrigatoria ausente",
  INCOMPATIBLE_DESTINATION: "Destino incompativel",
  DESTINATION_OUT_OF_ORDER: "Destino fora de servico",
  INVALID_NUMBER_FORMAT: "Formato de numero invalido",
  SUBSCRIBER_ABSENT: "Assinante ausente",
  LOSE_RACE: "Chamada perdida",
  UNKNOWN: "Desconhecido",
  DESCONHECIDO: "Desconhecido",
};

export function translateHangupCause(cause) {
  const value = String(cause || "").trim();
  if (!value) return "-";
  return HANGUP_CAUSE_LABELS[value.toUpperCase()] || value.replaceAll("_", " ");
}

export function translateAbandonmentCause(cause) {
  const value = String(cause || "").trim();
  if (!value) return "-";
  const normalized = value.toUpperCase();
  if (normalized === "TIMEOUT") return "Tempo esgotado";
  if (normalized === "ORIGINATOR_CANCEL") return "Desistencia do chamador";
  if (normalized === "USER_BUSY") return "Agentes ocupados";
  return translateHangupCause(value);
}
